export const getMissingGuestLeadFields = (form, guestMode) => {
  if (guestMode !== "new") return [];

  const missingFields = [];
  if (!`${form?.guest_first_name || ""}`.trim()) missingFields.push("First Name");
  if (!`${form?.guest_last_name || ""}`.trim()) missingFields.push("Last Name");
  if (!`${form?.guest_phone || ""}`.trim()) missingFields.push("Mobile Phone");
  return missingFields;
};
